import { extend, localize, setInteractionMode } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { isValidNumber } from "libphonenumber-js";
import tr from "vee-validate/dist/locale/tr";
import en from "vee-validate/dist/locale/en";
import de from "vee-validate/dist/locale/de";
import es from "vee-validate/dist/locale/es";
import it from "vee-validate/dist/locale/it";
import pt from "vee-validate/dist/locale/pt_PT";
import { i18n } from "@/plugins/i18n";
import { storageManager } from "../plugins/storage-manager";
import { LANGUAGE_KEY } from "../base/constants";
import { helpers } from "@/helpers/index";

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule]
  });
});

extend("integer", {
  ...rules.integer,
  message: (_, values) => {
    return i18n.t("validations.messages.integer", values);
  }
});

extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: (_, values) => {
    return i18n.t("validations.messages.password_match", values);
  }
});

extend("phone", {
  validate(value) {
    return isValidNumber(value);
  },
  message: (_, values) => {
    return i18n.t("validations.messages.phone", values);
  }
});

extend("validDescription", {
  validate(value, { min }) {
    if (!value) return false;
    const cleaned = value.replace(/[\s.,@!#$%^&*()_+=\-[\]{};':"\\|<>\/?`~]/g, "").trim();
    return cleaned.length >= min;
  },
  params: ["min"],
  message: () => i18n.t("validations.messages.meaningful_text")
});

extend("currency_format", {
  params: ["min", "max", "currency"],
  message: (_, values) => {
    return i18n.t("validations.messages.amount_range_error", values);
  },
  validate: (value, { min, max, currency }) => {
    const minValue = parseFloat(min);
    const maxValue = parseFloat(max);

    let numericValue = helpers.parseCurrency(value, helpers.getCurrencyLocale(currency));

    if (!numericValue) {
      return { valid: false };
    }

    return numericValue >= minValue && numericValue <= maxValue ? { valid: true } : { valid: false };
  }
});

localize({
  en,
  tr,
  de,
  es,
  it,
  pt
});

setInteractionMode("passive");

localize(storageManager.get(LANGUAGE_KEY) || "tr");
